import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function GalleryCTA({ image }: { image?: string }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const waLink = i18n.language === 'es'
    ? 'https://wa.me/19862173604?text=Hola%2C%20quiero%20hacer%20un%20pedido.%20%2F%20Hello%2C%20I%20want%20to%20place%20an%20order.'
    : 'https://wa.me/19862173604?text=Hola%2C%20quiero%20hacer%20un%20pedido.%20%2F%20Hello%2C%20I%20want%20to%20place%20an%20order.';

  return (
    <section className="relative rounded-2xl overflow-hidden mb-16">
      {/* Background */}
      <img
        src={image || "https://readdy.ai/api/search-image?query=Colombian%20food%20truck%20night%20scene%20urban%20street%20food%20Boise%20Idaho%20dark%20moody%20atmosphere%20orange%20lights%20grill%20smoke%20burgers%20hot%20dogs%20Latin%20food%20truck%20exterior%20vibrant%20energy%20cinematic%20wide%20shot%20premium&width=1400&height=500&seq=gcta1&orientation=landscape"}
        alt="Order from Bucara Burger – Colombian food truck Boise"
        className="w-full h-64 md:h-80 object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/95 via-black/80 to-black/50 flex items-center">
        <div className="px-8 md:px-14 max-w-2xl">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2 text-[#F57F25] text-xs font-bold uppercase tracking-widest mb-3">
            <div className="w-6 h-px bg-[#F57F25]"></div>
            {t('gallery_cta_eyebrow')}
          </div>

          <h2 className="text-white font-black text-3xl md:text-4xl uppercase leading-tight mb-6">
            {t('gallery_cta_title')}<br />
            <span className="text-[#F57F25]">{t('gallery_cta_title_accent')}</span>
          </h2>

          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={() => navigate('/menu')}
              className="flex items-center justify-center gap-2 bg-[#F57F25] hover:bg-[#e06d15] text-black font-bold text-sm px-6 py-3 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-restaurant-line text-base"></i>
              </div>
              {t('btn_view_menu')}
            </button>
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#1ebe5d] text-white font-bold text-sm px-6 py-3 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-base"></i>
              </div>
              {t('btn_order_whatsapp')}
            </a>
            <a
              href="tel:+19862173604"
              className="flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/20 text-white font-bold text-sm px-6 py-3 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-phone-line text-base"></i>
              </div>
              {t('btn_call_now')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
